import { render, staticRenderFns } from "./showTypeStatus.vue?vue&type=template&id=3e6b2f3e&"
import script from "./showTypeStatus.vue?vue&type=script&lang=js&"
export * from "./showTypeStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports